import { CSSObject } from '@emotion/react';

export const TextTitle: CSSObject = {
  '&&': {
    mb: '2',
    fontSize: ['sm', 'md'],
    fontWeight: 'medium',
  },
};
